
<div
	class="flow-sel-card-container"
	:selected="selected"
	:tabindex="tabindex"
	:disabled="disabled"
	@click="handleClick($event)"
>
	<slot />
</div>
